import { PaymentMethodEnum } from '@/types/common';
import type { ExcludeOtherPaymentMethod } from '@/types/common';
import { KlarnaForm } from '@/components/PaymentForms/KlarnaForm';
import { GooglePayForm } from '@/components/PaymentForms/GooglePayForm';
import { PaypalForm } from '@/components/PaymentForms/Paypal';
import { LinkPayForm } from '@/components/PaymentForms/LinkPayForm';
import { BlikPayForm } from '@/components/PaymentForms/BlikPayForm';
import { CashAppForm } from '@/components/PaymentForms/CashAppForm';
import { GenericPayForm } from '@/components/PaymentForms/GenericPayForm';
import { ApplePayForm } from '@/components/PaymentForms/ApplePayForm';
import { StripeGenericPayForm } from '@/components/PaymentForms/StripeGenericPayForm';
import { PaymentMethodsToStripe } from './stripe';

export const FormByPayment: Record<Partial<ExcludeOtherPaymentMethod>, React.ReactNode> = {
  [PaymentMethodEnum.KLARNA]: <KlarnaForm />,
  [PaymentMethodEnum.CASH_APP]: <CashAppForm />,
  [PaymentMethodEnum.LINK]: <LinkPayForm />,
  [PaymentMethodEnum.UNIONPAY]: <GenericPayForm paymentMethod={PaymentMethodEnum.UNIONPAY} />,
  [PaymentMethodEnum.VERIFON]: <GenericPayForm paymentMethod={PaymentMethodEnum.VERIFON} />,
  [PaymentMethodEnum.CREDIT_CARD]: null,
  [PaymentMethodEnum.APPLE_PAY]: <ApplePayForm />,
  [PaymentMethodEnum.GOOGLE_PAY]: <GooglePayForm />,
  [PaymentMethodEnum.PAYPAL]: <PaypalForm />,
  [PaymentMethodEnum.AMAZON_PAY]: (
    <StripeGenericPayForm paymentMethod={PaymentMethodsToStripe[PaymentMethodEnum.AMAZON_PAY]} />
  ),
  [PaymentMethodEnum.VENMO]: <GenericPayForm paymentMethod={PaymentMethodEnum.VENMO} />,
  [PaymentMethodEnum.AFTERPAY]: <GenericPayForm paymentMethod={PaymentMethodEnum.AFTERPAY} />,
  [PaymentMethodEnum.IDEAL]: <GenericPayForm paymentMethod={PaymentMethodEnum.IDEAL} />,
  [PaymentMethodEnum.AFFIRM]: <GenericPayForm paymentMethod={PaymentMethodEnum.AFFIRM} />,
  [PaymentMethodEnum.PIX]: <GenericPayForm paymentMethod={PaymentMethodEnum.PIX} />,
  [PaymentMethodEnum.NEOSURF]: <GenericPayForm paymentMethod={PaymentMethodEnum.NEOSURF} />,
  [PaymentMethodEnum.NUVEI_NEOSURF]: <GenericPayForm paymentMethod={PaymentMethodEnum.NUVEI_NEOSURF} />,
  [PaymentMethodEnum.BLIK]: <BlikPayForm />,
  [PaymentMethodEnum.BLIK_CHECKOUT]: <BlikPayForm />,
  [PaymentMethodEnum.P24]: <GenericPayForm paymentMethod={PaymentMethodEnum.P24} />,
  [PaymentMethodEnum.TRUSTLY]: <GenericPayForm paymentMethod={PaymentMethodEnum.TRUSTLY} />,
  [PaymentMethodEnum.EPS]: <GenericPayForm paymentMethod={PaymentMethodEnum.EPS} />,
  [PaymentMethodEnum.BANCONTACT]: <GenericPayForm paymentMethod={PaymentMethodEnum.BANCONTACT} />,
  [PaymentMethodEnum.ALIPAY]: <GenericPayForm paymentMethod={PaymentMethodEnum.ALIPAY} />,
  [PaymentMethodEnum.PAYME]: <GenericPayForm paymentMethod={PaymentMethodEnum.PAYME} />,
};

export const PaymentMethodsToShowLoaderWhileProcessing: PaymentMethodEnum[] = [
  PaymentMethodEnum.LINK,
  PaymentMethodEnum.APPLE_PAY,
  PaymentMethodEnum.GOOGLE_PAY,
  PaymentMethodEnum.PAYPAL,
  PaymentMethodEnum.AMAZON_PAY,
];
